// extracted by mini-css-extract-plugin
export default {"input":"LoadingInput-LoadingInput-module__input--Os6zT","reversed":"LoadingInput-LoadingInput-module__reversed--rZgJ2"};